import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gallery-surface border-t border-gallery-border py-12 px-6">
      <div className="max-w-7xl mx-auto flex flex-col items-center justify-center space-y-6">
        <div className="flex space-x-8">
          <a 
            href="https://instagram.com/gissellemendez2" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gallery-muted hover:text-gallery-accent transition-colors"
          >
            <SafeIcon name="Instagram" className="w-6 h-6" />
          </a>
          <a 
            href="mailto:contact@gissellemendez.com" 
            className="text-gallery-muted hover:text-gallery-accent transition-colors"
          >
            <SafeIcon name="Mail" className="w-6 h-6" />
          </a>
        </div>

        <div className="flex flex-col items-center space-y-2">
          <p className="text-xs uppercase tracking-[0.2em] text-gallery-muted">
            {t('footer.copyright')}
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy-policy" className="text-[10px] uppercase tracking-[0.2em] text-gallery-muted hover:text-gallery-accent transition-colors border-b border-transparent hover:border-gallery-accent pb-0.5">
              {t('footer.privacy')}
            </Link>
            <Link to="/legal-notice" className="text-[10px] uppercase tracking-[0.2em] text-gallery-muted hover:text-gallery-accent transition-colors border-b border-transparent hover:border-gallery-accent pb-0.5">
              {t('footer.legal')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;